import { render, staticRenderFns } from "./VIPclassxq.vue?vue&type=template&id=8b08bbb4&scoped=true"
import script from "./VIPclassxq.vue?vue&type=script&lang=js"
export * from "./VIPclassxq.vue?vue&type=script&lang=js"
import style0 from "./VIPclassxq.vue?vue&type=style&index=0&id=8b08bbb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b08bbb4",
  null
  
)

export default component.exports